/**
 * Serves a replacement for something like sleep(time), to let a function wait a set amount of time.
 * @param time
 * @returns
 */
export const delay = (time: number): Promise<any> => {
  return new Promise((resolve) => setTimeout(resolve, time));
};
